import { html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import componentStyles from './se-aside-layout.css.lit';
import { SlotController } from '../../controllers/slot-controller';

/**
 * The Aside Layout component.
 * @element se-aside-layout'
 */
@customElement('se-aside-layout')
export class SEAsideLayout extends OutlineElement {
  slots = new SlotController(this, false);
  static styles = [componentStyles];

  render(): TemplateResult {
    const aside = this.querySelector(`[slot="aside"]`);
    return html`
      <div class="wrapper ${aside ? 'aside' : ''}">
        <div class="main-content">
          <slot name="main-content"></slot>
        </div>
        <aside class="aside-content">
          <slot name="aside"></slot>
        </aside>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'aside-layout': SEAsideLayout;
  }
}
